import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import HoverActionButtons from '../buttons/HoverActionButtons';
import MarkdownContainer from './MarkdownContainer';

const HoverMarkdownContainer = ({
  as,
  className,
  value,
  canEdit,
  showEdit,
  position,
  toolTip = 'top left',
  editCopyMods,
  editText,
}) => {
  const intl = useIntl();
  return (
    <HoverActionButtons
      canEdit={canEdit}
      showEdit={showEdit}
      value={value}
      position={position}
      toolTip={toolTip}
      editCopyMods={editCopyMods}
    >
      <MarkdownContainer
        as={as}
        value={value || intl.formatMessage({ id: editText })}
        className={clsx('aridhia-hover-markdown-container', className)}
      />
    </HoverActionButtons>
  );
};

export default HoverMarkdownContainer;
